export const UNITS_FILTER_OPTIONS_KEY = "UNITS_FILTER_OPTIONS";
export const UNIT_MARK_VIEWED_KEY = "UNIT_MARK_VIEWED";
export const UNIT_MARK_ACTIVITY_READ_KEY = "UNIT_MARK_ACTIVITY_READ";
